<template>
  <div class="wechat-reply">
    <el-form ref="wechatReplyForm" :model="wechatReplyForm" :rules="wechatReplyFormRules" style="padding-right: 10px">
      <el-form-item label="步骤名称:" :label-width="addLabelWidth">
        <el-input class="stockInputs" disabled type="text" v-model="wechatReplyForm.name" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="微信账号:" prop="wechatId" :label-width="addLabelWidth" class="stockInputs">
        <el-select @blur="sendWechatReplyValue" @change="getDatas" v-model="wechatReplyForm.wechatId" placeholder="请选择微信账号" class="">
          <el-option
            v-for="item in wechatAcounts"
            :key="item.original_id"
            :label="item.nick_name"
            :value="item.original_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="text-align-left" label="内容类型:" :label-width="addLabelWidth">
        <template>
          <el-radio-group @change="changeContentType" v-model="wechatReplyForm.contentType">
            <el-radio :label="'text'" style="margin-left: 0;">文本</el-radio>
            <el-radio :label="'image'" style="margin-left: 10px;">图片</el-radio>
            <el-radio :label="'mpnews'" style="margin-left: 10px;">微页面</el-radio>
            <el-radio :label="'news'" style="margin-left: 10px;">外部页</el-radio>
            <el-radio :label="'big_wheel'" style="margin-left: 10px;">大转盘</el-radio>
          </el-radio-group>
        </template>
      </el-form-item>
      <!--文本-->
      <el-form-item v-if="wechatReplyForm.contentType === 'text'" label="输入文本:" :label-width="addLabelWidth" class="stockInput">
        <el-input
          type="textarea"
          @change="sendWechatReplyValue"
          autosize
          :rows="2"
          placeholder="请输入文本内容"
          v-model="wechatReplyForm.content">
        </el-input>
      </el-form-item>
      <!--图片-->
      <el-form-item v-if="wechatReplyForm.contentType === 'image'" label="上传图片:" :label-width="addLabelWidth" class="stockInput">
        <el-upload
          @change="sendWechatReplyValue"
          class="picture-uploader"
          :show-file-list="false"
          name="file_upload"
          :action="uploadURL"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <div v-if="imageUrl"  class="opacity-div">
            <img :src="imageUrl" class="notice-pic">
            <div class="back-div">点击更换</div>
          </div>
          <!-- <div slot="tip" style="line-height:20px;color:#606266;">必填！建议尺寸750*360</div> -->
          <img v-if="imageUrl === ''" src="../../assets/images/Group.png" class="default-images">
          <!-- <div v-if="imageUrl" class="upload_img">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <div class="modify_img">点击修改</div>
          </div>
          <img v-else src="../../assets/images/Group.png" class="default-acivity"> -->
          <!-- <div slot="tip" style="line-height:20px;color:#606266;">必填！建议尺寸340*340</div> -->
        </el-upload>
      </el-form-item>
      <!--微页面-->
      <el-form-item v-if="wechatReplyForm.contentType === 'mpnews'" label="微页面:" :label-width="addLabelWidth" class="stockInput">
        <el-select @change="sendWechatReplyValue" filterable v-model="wechatReplyForm.wePage" placeholder="请选择微页面" class="">
          <el-option
            v-for="item in wePages"
            :key="item.id"
            :label="item.admin_title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <!--外部页-->
      <!--输入链接-->
      <el-form-item v-if="wechatReplyForm.contentType === 'news'" label="输入链接:" :label-width="addLabelWidth" class="stockInput">
        <el-input
          @change="sendWechatReplyValue"
          type="input"
          autosize
          :rows="2"
          placeholder="请输入链接"
          v-model="wechatReplyForm.link">
        </el-input>
      </el-form-item>
      <!--输入标题-->
      <el-form-item v-if="wechatReplyForm.contentType === 'news'" label="输入标题:" :label-width="addLabelWidth" class="stockInput">
        <el-input
          @change="sendWechatReplyValue"
          type="input"
          autosize
          :rows="2"
          placeholder="请输入标题"
          v-model="wechatReplyForm.title">
        </el-input>
      </el-form-item>
      <!--输入摘要-->
      <el-form-item v-if="wechatReplyForm.contentType === 'news'" label="输入摘要:" :label-width="addLabelWidth" class="stockInput">
        <el-input
          @change="sendWechatReplyValue"
          type="input"
          autosize
          :rows="2"
          placeholder="请输入摘要"
          v-model="wechatReplyForm.main">
        </el-input>
      </el-form-item>
      <!--输入封面-->
      <el-form-item v-if="wechatReplyForm.contentType === 'news'" label="封面:" :label-width="addLabelWidth" class="stockInput">
        <el-upload
          @change="sendWechatReplyValue"
          class="picture-uploader"
          name="file_upload"
          :action="uploadURL"
          :show-file-list="false"
          :on-success="handleCoverAvatarSuccess"
          :before-upload="beforeCoverAvatarUpload">
          <div v-if="coverUrl"  class="opacity-div">
            <img :src="coverUrl" class="notice-pic">
            <div class="back-div">点击更换</div>
          </div>
          <img v-if="coverUrl === ''" src="../../assets/images/Group.png" class="default-images">
        </el-upload>
      </el-form-item>
      <!--大转盘-->
      <el-form-item v-if="wechatReplyForm.contentType === 'big_wheel'" label="大转盘:" :label-width="addLabelWidth" class="stockInput">
        <el-select @change="sendWechatReplyValue" filterable v-model="wechatReplyForm.big_wheel" placeholder="请选择大转盘" class="">
          <el-option
            v-for="item in bigWheels"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提示:" :label-width="addLabelWidth" class="stockInput">
        <div style="text-align: left;">受限于微信公众平台，消息推送仅限于48小时内与您认证服务号有交互的客户。</div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getWechatPublicListForNode, getWePagesList, getBigWheelList } from '@/api/customer.js'
import { API_IMG_HOST, API_HOST } from '../../api/local.js'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      wechatReplyFormRules: {
        wechatId: [
          { required: true, message: '微信账号不能为空', trigger: 'change' }
        ]
      },
      addLabelWidth: '90px',
      wechatReplyForm: this.contents,
      wechatAcounts: [
        {
          id: 0,
          name: '景芝酒业'
        },
        {
          id: 1,
          name: '哈哈虎'
        }
      ],
      imageUrl: '',
      searchForm: {
        publish_status: 1,
        public_id: ''
      },
      coverUrl: '',
      wePages: [],
      bigWheels: [],
      page: 1,
      API_IMG_HOST: API_IMG_HOST,
      newContents: {},
      header: {
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId')
      }
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    },
    coverImg() {
      return API_IMG_HOST + this.coverUrl
    },
    image() {
      return API_IMG_HOST + this.imageUrl
    }
  },
  methods: {
    // 公众号改变
    getDatas() {
      this.wechatReplyForm.wePage = ''
      this.wechatReplyForm.big_wheel = ''
      for (let i of this.wechatAcounts) {
        if (i.original_id === this.wechatReplyForm.wechatId) {
          this.searchForm.public_id = i.id
        }
      }
      this.loadWePages()
      this.loadBigWheelList()
    },
    // 传值到父组件
    sendWechatReplyValue() {
      // 传值到父组件
      let choose = {}
      choose.nodeType = 'wechatReplyNode'
      choose.name = this.wechatReplyForm.name
      choose.id = this.wechatReplyForm.id
      choose.wechatId = this.wechatReplyForm.wechatId
      choose.contentType = this.wechatReplyForm.contentType
      choose.content = this.wechatReplyForm.content
      choose.wePage = this.wechatReplyForm.wePage
      choose.big_wheel = this.wechatReplyForm.big_wheel
      choose.link = this.wechatReplyForm.link
      choose.title = this.wechatReplyForm.title
      choose.main = this.wechatReplyForm.main
      choose.imageUrl = this.imageUrl
      choose.coverUrl = this.coverUrl
      this.$emit('transform', choose)
    },
    // 切换内容类型的时候
    changeContentType(val) {
      if (val === 'mpnews' || val === 'big_wheel') {
        if (this.wechatReplyForm.wechatId === '') {
          console.log('101', this.wechatReplyForm.wechatId)
          this.wePages = []
          this.bigWheels = []
          _g.toastMsg('error', '请选择公众号')
        }
      }
      this.wechatReplyForm.content = ''
      this.wechatReplyForm.wePage = ''
      this.wechatReplyForm.big_wheel = ''
      this.wechatReplyForm.link = ''
      this.wechatReplyForm.title = ''
      this.wechatReplyForm.main = ''
      this.imageUrl = ''
      this.coverUrl = ''
      this.sendWechatReplyValue()
    },
    // @todo
    // 图片
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data.path
      this.sendWechatReplyValue()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M)
    },
    // 封面
    handleCoverAvatarSuccess(res, file) {
      this.coverUrl = res.data.path
      this.sendWechatReplyValue()
    },
    beforeCoverAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M)
    },
    // 加载公众号列表
    loadWechatPublic() {
      getWechatPublicListForNode(this.page).then((res) => {
        if (res.data.code === 0) {
          this.wechatAcounts = res.data.data.list
        }
      })
    },
    // 加载微页面列表
    loadWePages() {
      getWePagesList(1, '', this.searchForm).then((res) => {
        if (res.data.code === 0) {
          this.wePages = res.data.data.list
          let flag = 0
          this.wePages.some(item => {
            if (item.id !== this.wechatReplyForm.wePage) {
              flag++
            }
            if (flag === this.wePages.length) {
              this.wechatReplyForm.wePage = ''
            }
          })
        }
      })
    },
    // 请求大转盘列表
    loadBigWheelList() {
      this.searchForm.status = 1
      getBigWheelList(this.searchForm).then((res) => {
        if (res.data.code === 0) {
          this.bigWheels = res.data.data.list
          let flag = 0
          this.bigWheels.some(item => {
            if (item.id !== this.wechatReplyForm.big_wheel) {
              flag++
            }
            if (flag === this.bigWheels.length) {
              this.wechatReplyForm.big_wheel = ''
            }
          })
        }
      })
    }
  },
  watch: {
    contents: function (val) {
      this.wechatReplyForm = val
    }
  },
  created() {
    this.API_IMG_HOST = API_IMG_HOST
    this.loadWechatPublic()
    this.loadWePages()
    this.loadBigWheelList()
    this.imageUrl = this.wechatReplyForm.imageUrl
    this.coverUrl = this.wechatReplyForm.coverUrl
  }
}
</script>

<style scoped>
.upload_img{
  position: relative;
}
.upload_img:hover .modify_img{
  display: inline-block;
}
.opacity-div {
  width: 148px;
  height: 148px;
}
.opacity-div:hover .back-div {
  opacity: 1;
}
.back-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 148px;
  height: 148px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  color: #fff;
  line-height: 148px;
}
.notice-pic {
  width: 148px;
  height: 148px;
  display: inline-block;
  position: relative;
}
.default-images {
  width: 120px;
}
.picture-uploader {
  background: transparent;
  border: none;
  width: 148px;
  margin-left: 0px;
}
</style>
